import React from "react";

const UserDepartment = () => {
  return <div>UserDepartment</div>;
};

export default UserDepartment;
